import { useNavigate } from "react-router-dom";
import { Trash2, Minus, Plus, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useCart } from "../context/CartContext";
import { formatMXN } from "../lib/format";

export const CartSheet = () => {
  const { items, open, setOpen, updateQty, removeItem, subtotal, count } = useCart();
  const navigate = useNavigate();

  const goCheckout = () => {
    setOpen(false);
    navigate("/carrito");
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="flex w-full flex-col bg-white sm:max-w-md" data-testid="cart-sheet">
        <SheetHeader>
          <SheetTitle className="font-display text-brand-navy">
            Tu carrito ({count})
          </SheetTitle>
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center text-center text-slate-400">
            <ShoppingBag className="mb-3 h-12 w-12" />
            <p className="font-semibold">Tu carrito está vacío</p>
            <p className="text-sm">Explora nuestras certificaciones.</p>
          </div>
        ) : (
          <>
            <div className="flex-1 space-y-4 overflow-y-auto py-4">
              {items.map((item) => (
                <div key={item.product_id} data-testid={`cart-item-${item.product_id}`} className="flex gap-3">
                  <img src={item.image} alt={item.title} className="h-16 w-16 flex-none rounded-lg object-cover" />
                  <div className="min-w-0 flex-1">
                    <p className="line-clamp-2 text-sm font-semibold text-brand-navy">{item.title}</p>
                    <p className="text-sm font-bold text-brand-forest">{formatMXN(item.price)}</p>
                    <div className="mt-1 flex items-center gap-2">
                      <button onClick={() => updateQty(item.product_id, item.quantity - 1)} className="rounded-md border border-slate-200 p-1">
                        <Minus className="h-3.5 w-3.5" />
                      </button>
                      <span className="w-6 text-center text-sm font-semibold">{item.quantity}</span>
                      <button onClick={() => updateQty(item.product_id, item.quantity + 1)} className="rounded-md border border-slate-200 p-1">
                        <Plus className="h-3.5 w-3.5" />
                      </button>
                      <button onClick={() => removeItem(item.product_id)} className="ml-auto text-slate-400 hover:text-rose-500">
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-slate-200 pt-4">
              <div className="mb-3 flex items-center justify-between">
                <span className="text-sm text-slate-500">Subtotal</span>
                <span className="font-display text-xl font-extrabold text-brand-navy">{formatMXN(subtotal)}</span>
              </div>
              <button
                data-testid="cart-checkout-button"
                onClick={goCheckout}
                className="w-full rounded-xl brand-navy py-3.5 text-sm font-bold text-white transition-transform hover:scale-[1.02]"
              >
                Proceder al pago
              </button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
